import { LitElement } from 'lit';
import { html, css } from 'lit';
import '../../Time/Timestamp';
import '../../ReadMark/SingleMark/SingleMark.js';
import '../../ReadMark/BlueReadMark/BlueReadMark.js';
import '../../ReadMark/DoubleMark/DoubleMark.js';
import '../../ReadMark/ClockMark/ClockMark.js';
import { parseMessageWithLink } from '../../../../lib/helpers.js';
import { processTextWithMentions } from '../../../../lib/taguser.js';
import '../../EmojiReactions/EmojiReactions.js';
import '../../Popup/ConfirmationPopup/DeleteConfirmationPopup/DeletePopup.js';
import '../../../../components/ChatUIComponent/ReactionContainer.js';
import'../../ForwardMessage/ForwardUi.js'
class VideoMessageBubble extends LitElement {
  static properties = {
    bgColor: { type: String },
    borderWidth: { type: String },
    borderColor: { type: String },
    borderStyle: { type: String },
    borderRadius: { type: String },
    padding: { type: String },
    videoSrc: { type: String },
    videoType: { type: String },
    time: { type: String },
    height: { type: String },
    width: { type: String },
    playing: { type: Boolean },
    isRead: { type: Boolean },
    isSelf: { type: Boolean },
    isDelivered: { type: String },
    textColor: { type: String },
    message: { type: String },
    mentionedUsers: { type: Array },
    messageId: { type: String },
    reactions: { type: Object },
    showConfirmationPopup: { type: Boolean },
    selectedEmojiToRemove: { type: Object },
    showAllReactionsPopup: {type: Boolean},
    showReactionButton: {type: Boolean},
    showEmojiReactions: {type: Boolean},
    userMetaData: {type: Object},
    messageType: { type: Number },
    timeColor: { type: String },
    showReactionOnHover: { type: Boolean },
  };

  constructor() {
    super();
    this.playing = false;
    this.isPopupOpen = false;
    this.mentionedUsers = [];
    this.showReactionButton = false;
    this.showEmojiReactions = false;
    this.reactions = {};
    this.showAllReactionsPopup = false;
    this.showReactionOnHover = true;
  }

  static styles = css`
    reaction-container {
      display: block;
       min-height: 150px;
       max-height: fit-content;
       min-width: 300px;
       max-width: 400px;
       position: absolute;
       z-index: 100;
    }
    .video-message-container {
      width: fit-content;
      position: relative;
    }

    .time-stamp-container {
      position: absolute;
      bottom: 3px;
      right: 10px;
      font-size: 12px;
      display: flex;
      align-items: center;
      gap: 3px;
      margin-bottom: 10px;
    }

    .controls {
      display: flex;
      justify-content: start;
      gap: 10px;
    }

    .controls button {
      padding: 5px 10px;
      border: none;
      cursor: pointer;
      background: transparent;
      border-radius: 5px;
    }

    .video_play {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .video_pause {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .video_fullscreen {
      position: absolute;
      right: 10px;
      bottom: 25px;
    }
    .actions {
      position: absolute;
      left: -15px;
      cursor: pointer;
      top: 5px;
    }

    .popup {
      position: absolute;
      top: 0px;
      left: -100px;
      background-color: white;
      border: 1px solid #eef1fa;
      border-radius: 5px;
      padding: 10px;
      box-shadow: 0 2px 10px #eef1fa;
      z-index: 10;
      display: flex;
      flex-items: column;
      align-items: center;
      justify-content: center;
    }

    .popup div {
      cursor: pointer;
    }

      .emoji-slider {
      position: absolute;
    }

    emoji-reactions {
      position: absolute;
      top: 15px;
      z-index: 99;
      left: 0;
    }

    .reaction-button {
      position: absolute;
      top: 50%;
      right: -25px;
      transform: translateY(-50%);
      cursor: pointer;
      z-index: 100;
    }

      .remaining-count {
      background-color: var(--bg-primary-light);
      font-size: 14px;
      display: flex;
      justify-content: center;
      color: var(--text-primary-color);
      width: 25px;
      cursor: pointer;
    }

    .reactions-display {
      position: absolute;
      bottom: -10px;
      right: 10px;
      display: grid;
      grid-template-columns: repeat(3, auto);
      gap: 0;
      margin-top: 4px;
      background-color: transparent;
    }

    .reaction-item {
      display: flex;
      align-items: center;
      gap: 2px;
      border-radius: 12px;
      font-size: 20px;
      cursor: pointer;
      background: var(--bg-secondary-color);
    }
  `;
  openPopup() {
    this.isPopupOpen = !this.isPopupOpen;
  }
  playVideo() {
    const video = this.shadowRoot.querySelector('video');
    video.play();
    this.playing = true;

    const container = this.shadowRoot.querySelector('.video-message-container');
    container.addEventListener('mouseenter', () => {
      if (this.playing) {
        this.showPauseButton();
      }
    });
    container.addEventListener('mouseleave', () => {
      this.hidePauseButton();
    });
  }

  pauseVideo() {
    const video = this.shadowRoot.querySelector('video');
    video.pause();
    this.playing = false;
    this.hidePauseButton();
  }

  showPauseButton() {
    const pauseButton = this.shadowRoot.querySelector('.video_pause');
    pauseButton.style.display = 'block';
  }

  hidePauseButton() {
    const pauseButton = this.shadowRoot.querySelector('.video_pause');
    pauseButton.style.display = 'none';
  }

  togglePlayPause() {
    if (this.playing) {
      this.pauseVideo();
    } else {
      this.playVideo();
    }
  }
  handleMentionClick = (user) => {
    this.dispatchEvent(
      new CustomEvent('tagUserClick', {
        detail: { userId: user?.userId, userName: user?.userName },
        bubbles: true,
        composed: true,
      })
    );
  };

  fullscreenVideo() {
    const video = this.shadowRoot.querySelector('video');
    if (video.requestFullscreen) {
      video.requestFullscreen();
    }
  }

  handleMouseEnter() {
    if(this.showReactionOnHover) {
    this.showReactionButton = true;
    }
  }


  handleReactionRemove(reaction) {
    this.showEmojiReactions = false;

    this.showConfirmationPopup = true;
    this.selectedEmojiToRemove = reaction;
    setTimeout(() => {
      document.addEventListener('click', this.handleOutsideClick)
    }, 100)
  }
  handleMouseLeave(e) {
    const messageContainer = this.renderRoot.querySelector('.message-container');
    const emojiReactions = this.renderRoot.querySelector('emoji-reactions');
    const reactionButton = this.renderRoot.querySelector('.reaction-button');

    const isEmojiSliderOpen = this.showEmojiReactions;

    const isMovingToMessage = messageContainer?.contains(e.relatedTarget);
    const isMovingToEmoji = emojiReactions && emojiReactions?.contains(e.relatedTarget);
    const isMovingToReactionButton = reactionButton && reactionButton?.contains(e.relatedTarget);

    if (!isMovingToMessage && !isMovingToEmoji && !isMovingToReactionButton) {
      this.showReactionButton = false;
      
      if (!isEmojiSliderOpen) {
        this.showEmojiReactions = false;
      }
    }
  }

  handleOutsideClick = (e) => {
    const emojiReactions = this.renderRoot.querySelector('emoji-reactions');
    const messageContainer = this.renderRoot.querySelector('.message-container');
    const reactionContainer = this.renderRoot.querySelector('reaction-container');
    
    const path = e.composedPath();
    
    if ((this.showEmojiReactions &&
      !path.includes(emojiReactions) &&
      !path.includes(messageContainer)) ||
      (this.showConfirmationPopup &&
      !path.includes(reactionContainer) &&
      !path.includes(messageContainer))
    ) {
      this.showEmojiReactions = false;
      this.showConfirmationPopup = false;
      document.removeEventListener('click', this.handleOutsideClick);
    }
  }
    toggleEmojiReactions() {
    this.showConfirmationPopup = false;

    this.showEmojiReactions = !this.showEmojiReactions;
    
    if (this.showEmojiReactions) {
      setTimeout(() => {
        document.addEventListener('click', this.handleOutsideClick);
      }, 100);
    }
  }
  handleEmojiClick(emoji) {
    const currentUserId = this.userMetaData?.userId;
    const usersForEmoji = this.reactions[emoji.id] || [];
    const hasReaction = usersForEmoji.includes(currentUserId);
  
    let existingReactionEmojiId = null;
  
    for (const [emojiId, userIds] of Object.entries(this.reactions)) {
      if (userIds.includes(currentUserId)) {
        existingReactionEmojiId = emojiId;
        break;
      }
    }
  
    if (existingReactionEmojiId && existingReactionEmojiId !== emoji.id) {
      this.dispatchEvent(
        new CustomEvent('reaction-removed', {
          detail: {
            messageId: this.messageId,
            emojiId: existingReactionEmojiId,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
  
    if (hasReaction) {
      this.dispatchEvent(
        new CustomEvent('reaction-removed', {
          detail: {
            messageId: this.messageId,
            emojiId: emoji.id,
          },
          bubbles: true,
          composed: true,
        }),
      );
    } else {
      this.dispatchEvent(
        new CustomEvent('reaction-added', {
          detail: {
            messageId: this.messageId,
            emojiId: emoji.id,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
  
    this.showEmojiReactions = false;
    document.removeEventListener('click', this.handleOutsideClick);
  }
  handleConfirmRemove() {
    if (this.selectedEmojiToRemove) {
      this.dispatchEvent(
        new CustomEvent('reaction-removed', {
          detail: {
            messageId: this.messageId,
            emojiId: this.selectedEmojiToRemove.emojiId,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
    this.closeConfirmationPopup();
  }

  closeConfirmationPopup() {
    this.showConfirmationPopup = false;
    this.selectedEmojiToRemove = null;
  }

  render() {

    const emojiList = document.createElement('emoji-reactions').emojis;
    const allReactions = Object.keys(this.reactions)
      .map(reaction => {
        const matchingEmoji = emojiList.find(emoji => emoji.id === reaction);
        return {
          emojiId: reaction,
          messageId: this.reactions[reaction],
          src: matchingEmoji?.src,
        };
      })
      .filter(reaction => Array.isArray(reaction.messageId) && reaction.messageId.length > 0); 
    
    const visibleReactions = allReactions.slice(0, 2);
    const remainingCount = allReactions.length > 2 ? allReactions.length - 2 : 0;
    return html`
      <div
         @mouseover="${() => this.handleMouseEnter()}"
        @mouseout="${e => this.handleMouseLeave(e)}"
        class="video-message-container"
        style="padding:${this.padding}; 
          border-width: ${this.borderWidth};
          border-color: ${this.borderColor};
          border-style:${this.borderStyle};
          border-radius:${this.borderRadius};
          background-color: ${this.bgColor}
         "
      >
        ${this.messageType === 1
          ? html`
             <forward-ui></forward-ui>
            `
          : null}
         ${!this.isSelf && this.showReactionButton
          ? html`
        <div class="reaction-button" @click="${() => this.toggleEmojiReactions()}"  ">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--text-primary-color)">
            <path d="M612-516q25 0 42.5-17.5T672-576q0-25-17.5-42.5T612-636q-25 0-42.5 17.5T552-576q0 25 17.5 42.5T612-516Zm-264 0q25 0 42.5-17.5T408-576q0-25-17.5-42.5T348-636q-25 0-42.5 17.5T288-576q0 25 17.5 42.5T348-516Zm132 228q60 0 110.5-31t79.5-84H290q29 53 79.5 84T480-288Zm.28 192Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30ZM480-480Zm0 312q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Z"/>
          </svg>
        </div>
      `
          : ''}

            ${this.showConfirmationPopup
          ? html` <reaction-container .messageId=${this.messageId} .userMetaData=${this.userMetaData} .reactions=${allReactions}></reaction-container> `
          : ''}
        ${this.showEmojiReactions
          ? html`
              <emoji-reactions .isOpen="${this.showEmojiReactions}" .onEmojiSelect="${emoji => this.handleEmojiClick(emoji)}" .selectedEmojis="${this.reactions}"></emoji-reactions>
            `
          : ''}

        <div class="reactions-display">
          ${visibleReactions?.map(
            reaction => html`
              <span class="reaction-item" @click="${() => this.handleReactionRemove(reaction)}"> ${reaction.src ? html`<span>${reaction.src}</span>` : ''} </span>
            `,
          )}
         ${remainingCount > 0
            ? html`
                <span @click="${() => this.handleReactionRemove(visibleReactions[0])}" class="reaction-item remaining-count"> +${remainingCount} </span>
              
              `
            : ''}
        </div>

        <div >
          <div class="time-stamp-container">
            <timestamp-element .time="${this.time || new Date().toISOString()}" .color="${this.timeColor}"></timestamp-element>
            ${this.isSelf
              ? this.isRead == true
                ? html`<blue-read-mark></blue-read-mark>`
                : this.isDelivered == 'true'
                  ? html`<double-mark></double-mark>`
                  : this.isDelivered == 'pending'
                    ? html`<clock-mark></clock-mark>`
                    : html`<single-mark></single-mark>`
              : null}
          </div>
          <video
            style="height: ${this.height || '150px'}; 
          width:${this.width || '150px'};
          object-fit: cover; 
          overflow: hidden;
          border-radius:${this.borderRadius};
          "
            @click="${this.togglePlayPause}"
          >
            <source src=${this.videoSrc} type=${this.videoType || 'video/mp4'} />
          </video>

          <div class="controls">
 ${this.message && !this.message.includes('AttachmentMessage:')
        ? html`
              <span style="font-size: 14px; color: ${this.textColor}">
               ${processTextWithMentions(this.message, this.mentionedUsers, this.handleMentionClick, this.isSelf)}
              </span>
            `
        : null}
            <button class="video_play" style="display: ${this.playing ? 'none' : 'block'};" @click="${this.playVideo}">
              <svg
                height="50px"
                width="50px"
                version="1.1"
                id="_x32_"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="-51.2 -51.2 614.40 614.40"
                xml:space="preserve"
                fill="#000000"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0" transform="translate(64,64), scale(0.75)">
                  <rect x="-51.2" y="-51.2" width="614.40" height="614.40" rx="307.2" fill="" strokewidth="0"></rect>
                </g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <style type="text/css">
                    .st0 {
                      fill: #eff1fa;
                    }
                  </style>
                  <g>
                    <path
                      class="st0"
                      d="M256,0C114.625,0,0,114.625,0,256c0,141.374,114.625,256,256,256c141.374,0,256-114.626,256-256 C512,114.625,397.374,0,256,0z M351.062,258.898l-144,85.945c-1.031,0.626-2.344,0.657-3.406,0.031 c-1.031-0.594-1.687-1.702-1.687-2.937v-85.946v-85.946c0-1.218,0.656-2.343,1.687-2.938c1.062-0.609,2.375-0.578,3.406,0.031 l144,85.962c1.031,0.586,1.641,1.718,1.641,2.89C352.703,257.187,352.094,258.297,351.062,258.898z"
                    ></path>
                  </g>
                </g>
              </svg>
            </button>
            <button class="video_pause" style="display: ${this.playing ? 'block' : 'none'};" @click="${this.pauseVideo}">
              <svg width="60px" height="60px" viewBox="-2.4 -2.4 28.80 28.80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="SVGRepo_bgCarrier" stroke-width="0" transform="translate(3.959999999999999,3.959999999999999), scale(0.67)">
                  <rect x="-2.4" y="-2.4" width="28.80" height="28.80" rx="14.4" fill="#000" strokewidth="0"></rect>
                </g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM8.07612 8.61732C8 8.80109 8 9.03406 8 9.5V14.5C8 14.9659 8 15.1989 8.07612 15.3827C8.17761 15.6277 8.37229 15.8224 8.61732 15.9239C8.80109 16 9.03406 16 9.5 16C9.96594 16 10.1989 16 10.3827 15.9239C10.6277 15.8224 10.8224 15.6277 10.9239 15.3827C11 15.1989 11 14.9659 11 14.5V9.5C11 9.03406 11 8.80109 10.9239 8.61732C10.8224 8.37229 10.6277 8.17761 10.3827 8.07612C10.1989 8 9.96594 8 9.5 8C9.03406 8 8.80109 8 8.61732 8.07612C8.37229 8.17761 8.17761 8.37229 8.07612 8.61732ZM13.0761 8.61732C13 8.80109 13 9.03406 13 9.5V14.5C13 14.9659 13 15.1989 13.0761 15.3827C13.1776 15.6277 13.3723 15.8224 13.6173 15.9239C13.8011 16 14.0341 16 14.5 16C14.9659 16 15.1989 16 15.3827 15.9239C15.6277 15.8224 15.8224 15.6277 15.9239 15.3827C16 15.1989 16 14.9659 16 14.5V9.5C16 9.03406 16 8.80109 15.9239 8.61732C15.8224 8.37229 15.6277 8.17761 15.3827 8.07612C15.1989 8 14.9659 8 14.5 8C14.0341 8 13.8011 8 13.6173 8.07612C13.3723 8.17761 13.1776 8.37229 13.0761 8.61732Z"
                    fill="#EFF1FA"
                  ></path>
                </g>
              </svg>
            </button>
            <button class="video_fullscreen" @click="${this.fullscreenVideo}">
              <svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M23 4C23 2.34315 21.6569 1 20 1H16C15.4477 1 15 1.44772 15 2C15 2.55228 15.4477 3 16 3H20C20.5523 3 21 3.44772 21 4V8C21 8.55228 21.4477 9 22 9C22.5523 9 23 8.55228 23 8V4Z"
                    fill="#fff"
                  ></path>
                  <path
                    d="M23 16C23 15.4477 22.5523 15 22 15C21.4477 15 21 15.4477 21 16V20C21 20.5523 20.5523 21 20 21H16C15.4477 21 15 21.4477 15 22C15 22.5523 15.4477 23 16 23H20C21.6569 23 23 21.6569 23 20V16Z"
                    fill="#fff"
                  ></path>
                  <path
                    d="M4 21H8C8.55228 21 9 21.4477 9 22C9 22.5523 8.55228 23 8 23H4C2.34315 23 1 21.6569 1 20V16C1 15.4477 1.44772 15 2 15C2.55228 15 3 15.4477 3 16V20C3 20.5523 3.44772 21 4 21Z"
                    fill="#fff"
                  ></path>
                  <path
                    d="M1 8C1 8.55228 1.44772 9 2 9C2.55228 9 3 8.55228 3 8L3 4C3 3.44772 3.44772 3 4 3H8C8.55228 3 9 2.55228 9 2C9 1.44772 8.55228 1 8 1H4C2.34315 1 1 2.34315 1 4V8Z"
                    fill="#fff"
                  ></path>
                </g>
              </svg>
            </button>
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define('video-message', VideoMessageBubble);
export { VideoMessageBubble };
